import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BOOKING_TYPE } from '../models/enums';

@Pipe({
  name: 'bookingTypeFormatter',
  pure: false,
})
export class BookingTypeFormatterPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: BOOKING_TYPE, ...args: any[]): any {
    if (!value) {
      return value;
    }

    let resultDate = this.getResult(value);

    this.translateService.onLangChange.subscribe(() => {
      resultDate = this.getResult(value);
    });

    return resultDate;
  }

  private getResult(type: BOOKING_TYPE): string {
    return this.translateService.instant(`pipes.booking_type.${type}`);
  }
}
